<template>
  <div class="modal-card create-review" style="width:auto;">
    <header class="modal-card-head">
      <p class="modal-card-title">Create Review</p>
    </header>
    <section class="modal-card-body">
      <div>
        <div class="columns">
          <div class="column is-12 task-meta">
            <o-field
              label="Period"
              :type="fieldType('period')"
              :message="getError('period')"
            >
              <datepicker :error="getError('period')" v-model="review.period"  />
            </o-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6 task-meta">
            <o-field
              label="Previous EF Rating"
            >
              {{ review.previous_rating || 0 }}%
            </o-field>
          </div>
          <div class="column is-6 task-meta">
            <o-field
              label="Current EF Rating"
            >
              {{ review.rating || 0 }}%
            </o-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12 " style="height: 240px;overflow: scroll;">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Description</th>
                  <th>Rating</th>
                  <th>Previous Rating</th>
                  <th v-if="!item"><a @click="addItem">Add</a></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="itemReview in review.data" :key="itemReview.hash">
                  <td><input v-if="itemReview.IsEditing" v-model="itemReview.category"><span v-if="!itemReview.IsEditing"> {{ itemReview.category }}</span></td>
                  <td style="width:200px"><input v-if="itemReview.IsEditing" v-model="itemReview.description"><span v-if="!itemReview.IsEditing">{{ itemReview.description }}</span></td>
<!--                  <td><star-rating v-model="itemReview.rating" :star-size="20" /></td>-->
<!--                  <td><star-rating v-model="itemReview.previowsRating" :read-only="true" :star-size="20" active-color="#dfde97" /></td>-->
                  <td v-if="!item"><a @click="toggleEdit(itemReview)">{{ !itemReview.IsEditing ? "Edit Item" : "Save" }}</a>
                  <a  @click="removeItem(itemReview)">Remove</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12 task-meta">
            <o-field
              label="Comments"
              :type="fieldType('comments')"
              :message="getError('comments')"
            >
              <o-input maxlength="200" v-model="review.comments" type="textarea"></o-input>
            </o-field>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <div class="float-right">
        <button v-if="!item" @click.prevent="handleCreate" class="button is-success">
          Save
        </button>
        <button @click="$parent.$parent.$emit('update:active', false)" class="button" >Cancel</button>
      </div>
    </footer>
  </div>
</template>

<script>
import SelectContactModal from "./SelectContact";
import Datepicker from "../Datepicker";
import HandlesForm from "../../mixins/HandlesForm";
import { mapActions, mapGetters } from "vuex";
import StarRating from 'vue-star-rating'




export default {
  mixins: [HandlesForm],

  components: {
    Datepicker,
    SelectContactModal,
    StarRating
  },
  props: {
    user_id: {
      type: Number, // change-order, proposal
    },
    project_service_id: {
      type: Number,
    },
    application_type: {
      type: String,
    },
    application_id: {
      type: Number,
    },
    item: {
      type: undefined
    },
    previousItem: {
      type: undefined
    },
    period: {
      type: undefined
    }, 
    efRating: {
      type: Number
    }
  },

  data() {
    return {
      review: {
        user_id: null,
        period: moment().format('YYYY-MM-DD'),
        date: moment().format('YYYY-MM-DD'),
        rating: 0,
        previous_rating: 0,
        user_reviewer_id: null,
        data: [],
        comments: '',
        IsEditing: false
      },
      categories: [
            'Technical Knowlege',
            'Quality of work product',
            'Project Management Skills',
            'time management & organiztional',
            'Interpersonal',
            'Communication',
            'Thinking outside the box',
            'Collaboration/teamwork/mentoring skills',
            'Leadership skills',
            'Professionalism'
      ],
    };
  },

  mounted() {
    if(this.item) {
      this.review = this.item
    } else {
      this.review.user_reviewer_id = this.currentUserId
      this.review.user_id = this.user_id
      this.review.period = this.period
      this.review.rating = this.efRating
      if(this.previousItem) {
        this.review.data = this.previousItem.data.map(p => {return { hash: Math.random(), category: p.category, description: p.description, rating: 0, previowsRating: p.rating, IsEditing: false } })
        this.review.previous_rating = this.previousItem.rating
      } else {
        this.review.data = this.categories.map(p => { return { hash: Math.random(), category: p, description : '', rating: 0, previowsRating: 0, IsEditing: false} })
      }
    }
  },

  computed: {
    ...mapGetters([
      "currentUserId"
    ]),
  },


  methods: {
    ...mapActions([
      'createUserReview'
    ]),

    handleCreate() {
      let submit = this.wrapSubmit(this.createUserReview);

      submit({ user : { id: this.user_id }, review: this.review }).then((res) => {
        this.successMessage("Task has been successfull created");
        this.$emit('modalButtonClick', null)
        this.$parent.$parent.$emit('update:active', false);
        return res;
      });
    },
    toggleEdit(item) {
      item.IsEditing = !item.IsEditing
    },
    removeItem(item) {
      this.review.data.splice(this.review.data.indexOf(item), 1)
    },
    addItem() {
      this.review.data.push({ hash : Math.random(), category: '', description : '', rating: 0, previowsRating: 0, IsEditing: true})
    }

  },
};
</script>
<style lang="sass">
.modal-card
  width: 960px
  .modal-card-foot
    display: block
</style>
<style>
.create-review .table tr:nth-child(even) {background-color: #f2f2f2;}
.create-review .table tr:nth-child(odd) {background-color: #fff;}
.create-review .table thead { border-bottom: 1px solid #f0f0f0}
.create-review .table { border: none!important; }
.create-review .table .center-switch { width: 179px; text-align: center!important;}
.create-review tr.no-padding td { padding: 17px 9px; font-weight: bold; background-color: #e3e7ed; min-width: 165px; }
.create-review  td.td-description { width: 100%; }
.create-review textarea { min-height: 70px!important;}
</style>